import { render } from "./Or_pdfviewer.vue?vue&type=template&id=5a3ecd7f&ts=true"
import script from "./Or_pdfviewer.vue?vue&type=script&lang=ts"
export * from "./Or_pdfviewer.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__